const PAY_TYPES = [
  '支付宝扫码大额',
  '支付宝扫码小额',
  '支付宝转账大额',
  '支付宝转账小额',
  '支付宝固定大额',
  '支付宝固定小额',
  '微信扫码大额',
  '微信扫码小额',
  '微信转账大额',
  '微信转账小额',
  '微信定额大额',
  '微信定额小额',
  '银行卡转账大额',
  '银行卡转账小额',
];

function pad(n) {
  return String(n).padStart(2, '0');
}

function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function randomAmount() {
  const tier = Math.random();
  if (tier < 0.35) return (Math.random() * 2800 + 200).toFixed(2);
  if (tier < 0.7) return (Math.random() * 9000 + 3000).toFixed(2);
  return (Math.random() * 12000 + 8000).toFixed(2);
}

function calcCommission(amount, payType) {
  const n = Number(amount) || 0;
  let rate = 0.082 + Math.random() * 0.018;
  if (payType.includes('银行卡') && n > 8000) rate = 0.062 + Math.random() * 0.012;
  if (payType.includes('固定') && n < 3000) rate = 0.078 + Math.random() * 0.015;
  if (payType.includes('微信转账') && n < 3000) rate = 0.092 + Math.random() * 0.02;
  return (n * rate).toFixed(2);
}

function formatDateTime(date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} `
    + `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

function makeOrderId(date) {
  const stamp =
    `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}`
    + `${pad(date.getHours())}${pad(date.getMinutes())}${pad(date.getSeconds())}`;
  return stamp + String(randomInt(100000, 999999));
}

/** 生成订单大厅 mock 数据（默认 8 条「等待抢单」） */
export function generateMockHallOrders(count = 8) {
  const now = Date.now();
  const orders = [];

  for (let i = 0; i < count; i += 1) {
    const payType = PAY_TYPES[randomInt(0, PAY_TYPES.length - 1)];
    const amount = randomAmount();
    const commission = calcCommission(amount, payType);
    const minutesAgo = randomInt(1, 55);
    const created = new Date(now - minutesAgo * 60 * 1000 - randomInt(0, 59) * 1000);

    orders.push({
      id: makeOrderId(created),
      status: '等待抢单',
      amount,
      commission,
      commissionDisplay: commission,
      createdAt: formatDateTime(created),
      payType,
      canTake: true,
    });
  }

  return orders.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
}

export const HALL_REFRESH_MS = 60 * 60 * 1000;
